import React from "react";
import {connect} from "react-redux";
import {Button, Card, Col, Container, Row, Nav, OverlayTrigger, Popover} from "react-bootstrap";
import NavItemOrder from "../NavItemOrder";
import FloatingBtn from "../buttons/FloatingBtn";
import ContinueButton from "../buttons/ContinueButton";
import Radium, {StyleRoot} from 'radium';
import {bounceIn} from 'react-animations';
import {resetState, getLastOrderData, moreServices} from "../../actions/actionCreators";
import {SELECT_SERVICE} from "../../actions/actionsTypes";
import { push } from 'connected-react-router'


const mapStateToProps = state => ({ ...state });
const mapDispatchToProps = dispatch => ({
	setService: number => dispatch({type: SELECT_SERVICE, number}),
	goToInvoice: id => dispatch(push(`/invoice/${id}`))
});

class MoreService extends React.Component{
  constructor(props){
	  super(props);
	  this.state = {
	   elements: [
	    {key: 'packing_service', name: 'کارگر ﺑﺴﺘﻪ ﺑﻨﺪﯼ'},
	    {key: 'layout_service', name: 'کارگر ﭼﯿﺪﻣﺎﻥ'},
	    {key: 'tech_service', name: 'کارگر ﻓﻨﯽ'},
	    {key: 'shop_service', name: 'فروشگاه'},
	   ],
	  };

      window.addEventListener("beforeunload", (ev) =>
      {
          resetState();
      });

	  moreServices();
	  this.props.setService(5);
    getLastOrderData();
  }

  componentWillUnmount() {
      resetState();
  }

  render(){

   return(
          <Container>
        	<Row className='justify-content-center' style={{marginTop: 20}}>
        		<Col sm={12} xs={12} md={10} lg={8} style={{ marginBottom: 100}} className='text-center'>
                <Card>
                  <Card.Body>
                    <FloatingBtn place='moreService'/>
                       <Nav className="justify-content-center"
                           style={{marginTop:'20px'}}>
                           {this.state.elements.map((element, key)=>{
                               return(
                                  <OverlayTrigger rootClose={true} trigger="click" placement="bottom"  overlay={
                                    <Popover id="popover-basic" style={{display: key === 3 && 'none'}}>
                                        <Popover.Content className={'head'} >
                                            {this.props.order.popover}
                                        </Popover.Content>
                                    </Popover>
                                }>
                                   <Col sm={3} xs={6} className="loader">
                                       <NavItemOrder unique={true} 
                                       quantity={key === 3 ? 'shop' : 'quantity'} 
                                       eventKey={element.key} 
                                       name={element.name}/>
                                   </Col>
                               </OverlayTrigger>
                               );
                           })}
                       </Nav>
                     </Card.Body>
                 	</Card>

                    <div>
                        <ContinueButton
                        submitText={'اضافه به سفارش'}
                        noBack showPrice
                        stepHandle={this.props.stepHandle}/>
                    </div>

                    </Col>
                </Row>
           </Container>
   );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(MoreService);